// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"708":"9145f4f74f17326186da","3392":"fe3194fe135d2f12b673","6245":"b6a8779f85cf748320b6","7091":"0f03a06e965d17ff54c3"}[chunkId] + ".css";
};